/* ✦ Freddy's "Save for Later" (wishlist) · preview theme only.
   List lives in localStorage "fj_wishlist" as [{h:handle,t:title,i:image,r:1 if ring,d:savedAt}], the same key RingWink reads.
   Signed-in customers: the account list printed in #fjs-server (fj_profile.wishlist + fj_profile.data.wish) is merged in once per change.
   Hearts: Liquid buttons [data-fjs] (snippets/fj-save-button.liquid) + auto-added hearts on custom cards (picks, gifts, demo, First Look). */
(function () {
  if (window.FJSave) return;
  var K = 'fj_wishlist', MK = 'fj_save_merged';
  var HEART = '<svg class="fjs-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.6-7.6-10.2A4.3 4.3 0 0 1 12 7.5a4.3 4.3 0 0 1 7.6 2.6c0 5.6-7.6 10.2-7.6 10.2z"/></svg>';
  var URL_SAVED = window.FJSaveURL || '/pages/contact?view=fj-saved';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load() { try { var a = JSON.parse(localStorage.getItem(K)); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }) : []; } catch (e) { return []; } }
  function store(a) { try { localStorage.setItem(K, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function dollars(c) { return '$' + Math.round((c || 0) / 100).toLocaleString('en-US'); }

  /* ---- merge the signed-in customer's account list (read-only from the theme) ---- */
  (function merge() {
    var el = document.getElementById('fjs-server'), s = null;
    try { s = el && JSON.parse(el.textContent); } catch (e) {}
    if (!s || !s.c) return;
    var srv = [].concat(s.w || [], Array.isArray(s.d) ? s.d : []).filter(function (x) { return x && x.h; });
    if (!srv.length) return;
    var sig = s.c + ':' + srv.map(function (x) { return x.h; }).sort().join(',');
    if (localStorage.getItem(MK) === sig) return;
    var a = load();
    srv.forEach(function (x) { if (!a.some(function (y) { return y.h === x.h; })) a.push({ h: x.h, t: x.t || '', i: x.i || '', d: Date.now() }); });
    store(a);
    try { localStorage.setItem(MK, sig); } catch (e) {}
  })();

  /* ---- toast ---- */
  var toastEl;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'fjs-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    var hdr = document.querySelector('.fjh-bar') || document.querySelector('header');
    var top = 12; if (hdr) { var r = hdr.getBoundingClientRect(); if (r.bottom > 0) top = Math.round(r.bottom + 10); }
    toastEl.style.top = top + 'px';
    toastEl.innerHTML = html; toastEl.classList.remove('is-on'); void toastEl.offsetWidth; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---- paint every heart + header count ---- */
  function paint() {
    var a = load(), set = {};
    a.forEach(function (x) { set[x.h] = 1; });
    document.querySelectorAll('[data-fjs]').forEach(function (b) {
      var on = !!set[b.dataset.h];
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', on);
      var t = b.dataset.t || 'this piece', al = (on ? 'Saved for later: ' : 'Save for later: ') + t;
      if (b.getAttribute('aria-label') !== al) b.setAttribute('aria-label', al);
      var l = b.querySelector('.fjs-lbl'), lt = l && (on ? l.dataset.on : l.dataset.off); if (l && l.textContent !== lt) l.textContent = lt;
    });
    document.querySelectorAll('[data-fjs-count]').forEach(function (c) { var v = String(a.length > 99 ? '99+' : a.length); if (c.textContent !== v) c.textContent = v; c.hidden = !a.length; });
    document.querySelectorAll('[data-fjs-hdr]').forEach(function (h) { h.setAttribute('aria-label', 'Saved for later' + (a.length ? ', ' + a.length + (a.length === 1 ? ' piece' : ' pieces') : '')); });
  }

  function toggle(item, btn) {
    var a = load(), i = -1;
    a.forEach(function (x, k) { if (x.h === item.h) i = k; });
    if (i > -1) a.splice(i, 1);
    else { var o = { h: item.h, t: item.t || '', i: item.i || '', d: Date.now() }; if (item.r) o.r = 1; a.push(o); }
    store(a); paint();
    if (btn && i < 0) { btn.classList.remove('fjs-pop'); void btn.offsetWidth; btn.classList.add('fjs-pop'); }
    toast(i < 0 ? 'Saved for later <span class="fjs-sp">✦</span> <a href="' + esc(URL_SAVED) + '">View saved</a>' : 'Removed from saved');
    document.dispatchEvent(new CustomEvent('fj:saved', { detail: { list: a, handle: item.h, saved: i < 0 } }));
    return i < 0;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fjs]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (!b.dataset.h) return;
    toggle({ h: b.dataset.h, t: b.dataset.t, i: b.dataset.i, r: b.dataset.r }, b);
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === K) paint(); });
  window.addEventListener('pageshow', paint);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) paint(); });

  /* ---- auto hearts on custom (non card-product) cards ---- */
  function handleOf(href) { var m = /\/products\/([^\/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function addHeart(host, h, t, i) {
    if (!host || !h || host.querySelector(':scope > .fjs-heart')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'fjs-btn fjs-heart fjs-heart--auto'; b.setAttribute('data-fjs', '');
    b.dataset.h = h; b.dataset.t = t || ''; b.dataset.i = i || ''; b.setAttribute('aria-pressed', 'false');
    b.innerHTML = HEART;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(b);
  }
  function imgOf(root) { var im = root && root.querySelector('img'); return im ? (im.currentSrc || im.src || '') : ''; }
  var AUTO = [
    ['a.fjpk__c', '.fjpk__i', '.fjpk__ti'],
    ['a.fjgd__card', '.fjgd__img', '.fjgd__t'],
    ['.fjx-pc', '.fjx-pc__img', '.fjx-pc__t']
  ];
  var dia = null, diaP = null;
  function diamonds() {
    if (dia) return Promise.resolve(dia);
    if (diaP) return diaP;
    var s = document.querySelector('[data-fjnd-src]');
    if (!s) return Promise.resolve([]);
    diaP = fetch(s.getAttribute('data-fjnd-src')).then(function (r) { return r.json(); }).then(function (j) { dia = (j && j.diamonds) || []; return dia; }).catch(function () { return (dia = []); });
    return diaP;
  }
  function scan() {
    document.querySelectorAll('.card__inner > .fjs-heart').forEach(function (h) { h.parentNode.classList.add('fjs-lift'); });
    AUTO.forEach(function (d) {
      document.querySelectorAll(d[0]).forEach(function (c) {
        var a = c.matches('a') ? c : c.querySelector('a[href*="/products/"]');
        var h = handleOf(a && a.getAttribute('href'));
        var host = c.querySelector(d[1]);
        var te = c.querySelector(d[2]);
        addHeart(host, h, te ? te.textContent.trim() : '', imgOf(host));
      });
    });
    /* First Look diamonds (only the ones that are real store products, i.e. have Add to cart) */
    var nd = [].filter.call(document.querySelectorAll('.fjnd__c'), function (c) { return c.querySelector('[data-fjnd-add]') && !c.querySelector('.fjs-heart'); });
    if (nd.length) diamonds().then(function (list) {
      nd.forEach(function (c) {
        if (c.querySelector('.fjs-heart')) return;
        var t = (c.querySelector('.fjnd__t') || {}).textContent || '', sp = (c.querySelector('.fjnd__s') || {}).textContent || '';
        var price = parseInt(((c.querySelector('.fjnd__p') || {}).textContent || '').replace(/[^\d]/g, ''), 10);
        var parts = sp.split('·').map(function (x) { return x.trim(); });
        var hit = list.filter(function (d) {
          return d.variant_id && t.indexOf(Number(d.carat).toFixed(2) + ' ct') === 0 && Math.round(d.price) === price &&
            parts.indexOf(d.color) > -1 && parts.indexOf(d.clarity) > -1 && (!d.lab || parts.indexOf(d.lab) > -1);
        });
        if (hit.length > 1) { /* same-spec twins: tell them apart by the photo/poster URL */
          var src = imgOf(c.querySelector('.fjnd__m')) || ((c.querySelector('.fjnd__m img') || {}).getAttribute ? c.querySelector('.fjnd__m img').getAttribute('src') : '') || '';
          hit = hit.filter(function (d) { return (d.img && src.indexOf(d.img) > -1) || src.indexOf('fj-dposter-' + d.id + '.') > -1 || (d.video && src.indexOf(d.video.replace(/video\.mp4.*$/i, '')) > -1); });
        }
        if (hit.length !== 1) return;
        var d = hit[0], full = Number(d.carat).toFixed(2) + ' ct ' + d.shape + ' Diamond · ' + [d.color, d.clarity, d.lab].filter(Boolean).join(' · ');
        addHeart(c.querySelector('.fjnd__m'), 'fj-diamond-' + d.id, full, imgOf(c.querySelector('.fjnd__m')));
      });
      paint();
    });
    paint();
  }
  var mo, st;
  function boot() {
    scan();
    mo = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var n = ms[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType === 1 && !(n[j].classList && (n[j].classList.contains('fjs-heart') || n[j].classList.contains('fjs-toast')))) { clearTimeout(st); st = setTimeout(scan, 120); return; }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    if (document.querySelector('[data-fjs-page]')) page();
  }

  /* ---- Saved for Later page (sections/fj-saved.liquid) ---- */
  function isRing(p) {
    var ty = (p.type || '').toLowerCase(), probe = ty || (p.title || '').toLowerCase();
    if (/earring|necklace|pendant|bracelet|bangle|anklet|chain|watch|payment|deposit|service|gift card/.test(probe)) return false;
    if (/ring|band/.test(ty)) return true;
    if ((p.options || []).some(function (o) { return /ring size/i.test(o.name || o); })) return true;
    if ((p.tags || []).some(function (t) { return /^(ring|rings|band|bands|wedding band|engagement ring)$/i.test(t); })) return true;
    return !ty && /( ring|ring | band|band )/i.test(p.title || '');
  }
  function cartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var b = document.getElementById('cart-icon-bubble'); if (!b) return;
      var n = b.querySelector('.fjh-count');
      if (!n) { n = document.createElement('span'); n.className = 'fjh-count'; b.appendChild(n); }
      n.textContent = c.item_count; b.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items');
    }).catch(function () {});
  }
  function page() {
    var root = document.querySelector('[data-fjs-page]'), grid = root.querySelector('[data-fjs-grid]'), empty = root.querySelector('[data-fjs-empty]'), cnt = root.querySelector('[data-fjs-page-count]');
    var cache = {};
    function count(n) { cnt.textContent = n ? n + (n === 1 ? ' piece · ' : ' pieces · ') : ''; empty.hidden = !!n; grid.hidden = !n; }
    function cardHTML(x, p) {
      var url = '/products/' + encodeURIComponent(x.h);
      var img = (p && p.featured_image) || x.i || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var title = (p && p.title) || x.t || x.h;
      title = title.replace(/^\[TEST\]\s*/, '');
      var out = '<article class="fjs-card' + (p && p.vendor === 'Imagine Bridal' ? ' fj-ib' : '') + '" data-h="' + esc(x.h) + '">' +
        '<a class="fjs-card__img" href="' + url + '">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(title) + '">' : '') + '</a>' +
        '<button type="button" class="fjs-btn fjs-heart" data-fjs data-h="' + esc(x.h) + '" data-t="' + esc(title) + '" data-i="' + esc(x.i || '') + '" aria-pressed="true">' + HEART + '</button>' +
        '<div class="fjs-card__b"><a class="fjs-card__t" href="' + url + '">' + esc(title) + '</a>';
      if (p === false) return out + '<p class="fjs-card__na">No longer available</p></div></article>';
      if (!p) return out + '<p class="fjs-card__p">&nbsp;</p></div></article>';
      /* FJ 2026-10-16: no price yet (needs-price tag or $0) -> Call for price, no Add to cart */
      if ((p.tags || []).indexOf('needs-price') > -1 || !(p.price_max || p.price)) return out + '<p class="fjs-card__p fj-cfp">Call for price</p><a class="fjs-add" href="' + url + '">Ask for price</a></div></article>';
      var avail = p.variants.filter(function (v) { return v.available; });
      out += '<p class="fjs-card__p">' + (p.price_varies ? 'From ' : '') + dollars(p.price_min || p.price) + '</p>';
      if (!avail.length) return out + '<button type="button" class="fjs-add" disabled>Sold out</button></div></article>';
      if (x.r || isRing(p)) return out + '<a class="fjs-add" href="' + url + '">Choose size</a></div></article>';
      if (p.variants.length > 1) {
        out += '<select class="fjs-var" aria-label="Choose an option for ' + esc(title) + '">' + avail.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + ' · ' + dollars(v.price) + '</option>'; }).join('') + '</select>';
      }
      return out + '<button type="button" class="fjs-add" data-fjs-add="' + avail[0].id + '">Add to cart</button></div></article>';
    }
    function draw() {
      var a = load().slice().reverse();
      count(a.length);
      grid.innerHTML = a.map(function (x) { return cardHTML(x, cache[x.h]); }).join('');
      paint();
    }
    draw();
    load().forEach(function (x) {
      if (x.h in cache) return;
      fetch('/products/' + encodeURIComponent(x.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (r.status === 404) return false; if (!r.ok) throw 0; return r.json(); })
        .then(function (p) { cache[x.h] = p; var el = grid.querySelector('.fjs-card[data-h="' + CSS.escape(x.h) + '"]'); if (el) { var w = document.createElement('div'); w.innerHTML = cardHTML(x, p); el.replaceWith(w.firstChild); paint(); } })
        .catch(function () {});
    });
    document.addEventListener('fj:saved', function (e) {
      if (e.detail && e.detail.saved === false) {
        var el = grid.querySelector('.fjs-card[data-h="' + CSS.escape(e.detail.handle) + '"]');
        if (el) { el.classList.add('is-out'); setTimeout(function () { el.remove(); count(load().length); }, 220); }
      }
    });
    window.addEventListener('storage', function (e) { if (e.key === K) draw(); });
    grid.addEventListener('change', function (e) { var s = e.target.closest('.fjs-var'); if (s) s.parentNode.querySelector('[data-fjs-add]').dataset.fjsAdd = s.value; });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fjs-add]'); if (!b) return;
      b.disabled = true; var lbl = b.textContent; b.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.fjsAdd, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; b.textContent = 'Added'; toast('Added to cart <span class="fjs-sp">✦</span> <a href="/cart">View cart</a>'); cartCount(); setTimeout(function () { b.disabled = false; b.textContent = lbl; }, 1600); })
        .catch(function () { b.disabled = false; b.textContent = lbl; toast('Couldn\u2019t add that one. Please try again.'); });
    });
  }

  window.FJSave = { list: load, has: has, toggle: toggle, paint: paint, scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
